export default __webpack_public_path__ + "static/media/disclosure_icon.06e2a221.svg";